// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://explorer.inkonchain.com/address/0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73
export const GHO_TOKEN = '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73';

// https://explorer.inkonchain.com/address/0xDe6539018B095353A40753Dc54C91C68c9487D4E
export const GHO_CCIP_TOKEN_POOL = '0xDe6539018B095353A40753Dc54C91C68c9487D4E';

// https://explorer.inkonchain.com/address/0x20fd5f3FCac8883a3A0A2bBcD658A2d2c6EFa6B6
export const GHO_ORACLE = '0x20fd5f3FCac8883a3A0A2bBcD658A2d2c6EFa6B6';

// https://explorer.inkonchain.com/address/0xA5Ba213867E175A182a5dd6A9193C6158738105A
export const GHO_BUCKET_STEWARD = '0xA5Ba213867E175A182a5dd6A9193C6158738105A';

// https://explorer.inkonchain.com/address/0x2Ce400703dAcc37b7edFA99D228b8E70a4d3831B
export const GHO_CCIP_STEWARD = '0x2Ce400703dAcc37b7edFA99D228b8E70a4d3831B';

// https://explorer.inkonchain.com/address/0x8513e6F37dBc52De87b166980Fa3F50639694B60
export const RISK_COUNCIL = '0x8513e6F37dBc52De87b166980Fa3F50639694B60';

export const CHAIN_ID = 57073;
